import router from '@/router';
import { RouteRecordRaw } from 'vue-router';

export const registerRouteForModule = (routes: RouteRecordRaw[]) => {
    return {
        router: routes,
        addRoutes(parent: any) {
            routes.forEach((r: any) => parent.addRoute(r));
        }
    };
};

const registerModule = (name: string, module: any) => {
    if (module.router) {
        module.addRoutes(router);
    }
};

export const registerModules = (modules: any) => {
    Object.keys(modules).forEach(moduleKey => registerModule(moduleKey, modules[moduleKey]));
};
